import { Component, Host, h, Prop } from '@stencil/core';

export type JustifyContent =
  | 'flex-start'
  | 'flex-end'
  | 'center'
  | 'space-between'
  | 'space-around'
  | 'space-evenly';
export type AlignItems =
  | 'flex-start'
  | 'flex-end'
  | 'center'
  | 'baseline'
  | 'stretch';
export type FlexDirection = 'row' | 'row-reverse' | 'column' | 'column-reverse';
export type FlexWrap = 'nowrap' | 'wrap' | 'wrap-reverse';
export type AlignContent =
  | 'flex-start'
  | 'flex-end'
  | 'center'
  | 'space-between'
  | 'space-around'
  | 'stretch';
export type Gap = 'xs' | 'sm' | 'md' | 'lg';
export type AlignSelf =
  | 'center'
  | 'start'
  | 'end'
  | 'self-start'
  | 'self-end'
  | 'auto'
  | 'normal'
  | 'flex-start'
  | 'flex-end'
  | 'baseline'
  | 'first baseline'
  | 'last baseline'
  | 'stretch'
  | 'safe center'
  | 'unsafe center';
@Component({
  tag: 'uui-flexlayout',
  styleUrl: 'uui-flexlayout.css',
  shadow: true
})

/**
 * @slot default - items to render in flex container
 */
export class UuiFlexLayout {
  @Prop() justify: JustifyContent = 'flex-start';
  @Prop() alignItems: AlignItems = 'stretch';
  @Prop() direction: FlexDirection = 'row';
  @Prop() wrap: FlexWrap = 'nowrap';
  @Prop() alignContent: AlignContent = 'stretch';
  @Prop({ reflect: true }) gap?: Gap;
  /** only applicable if parent container is a flex container */
  @Prop() grow: number = 0;
  /** only applicable if parent container is a flex container */
  @Prop() shrink: number = 1;
  /** only applicable if parent container is a flex container */
  @Prop() basis: string = 'auto';
  /** only applicable if parent container is a flex container */
  @Prop() alignSelf: AlignSelf = 'auto';

  render() {
    const {
      justify,
      alignItems,
      direction,
      wrap,
      alignContent,
      grow,
      shrink,
      basis,
      alignSelf
    } = this;

    return (
      <Host
        style={{
          justifyContent: justify,
          alignItems: alignItems,
          flexGrow: grow.toString(),
          flexShrink: shrink.toString(),
          flexBasis: basis,
          alignSelf: alignSelf,
          flexDirection: direction,
          flexWrap: wrap,
          alignContent: alignContent
        }}
      >
        <slot></slot>
      </Host>
    );
  }
}
